/*
Copyright 2025 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const BoxIcon = ({ width = 24, height = 24, hidden = false, title = 'Box' } = {}):
  | string
  | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    height="${height}"
    viewBox="0 0 36 36"
    width="${width}"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <path
      d="M16.4 35.594 2.823 28.051A1.6 1.6 0 0 1 2 26.652V13.194l14.4 8ZM33.177 28.051 19.6 35.594v-14.4l14.4-8v13.458a1.6 1.6 0 0 1-.823 1.399ZM24.637 3.717 18.762.535a1.6 1.6 0 0 0-1.524 0L2.592 8.468a.825.825 0 0 0 0 1.451l5.529 2.995ZM33.408 8.468 27.97 5.523l-16.515 9.2L18 18.265l15.408-8.346a.825.825 0 0 0 0-1.451Z"
    />
  </svg>`;
};
